export default "__VITE_ASSET__DY11HNiL__"